import styled from "styled-components";
import { colors } from "../../styled/varibles";

export const SideBarSC = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 1.6rem 1.2rem;
    gap: 1rem;
    width: 100%;
    background: ${colors.bgMenu};
    border-right: 1px solid ${colors.stroke};
`;
export const StagesContainerSC = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0px;
    gap: 1.3rem;
`;

export const TitleSC = styled.div`
    font-family: "Inter";
    font-style: normal;
    font-weight: 600;
    font-size: 2rem;
    line-height: 160%;
    text-align: center;
    letter-spacing: -0.01em;
    color: ${colors.textColor};
`;

export const StagesSC = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1.8rem;
`;

export const StageSC = styled.div`
    width: 46px;
    height: 46px;
    background: ${colors.white};
    border: 1px solid ${colors.stroke};
    border-radius: 50%;
`;
